import * as ngCore from '@angular/core'

@ngCore.Directive({
  selector: '[atnDsMeasuredElement]',
  standalone: true,
})
export class AtnDsMeasuredElement<TContext = any> {
  /**
   * {@link ngCore.ElementRef<HTMLElement> ElementRef} to which directive is attached
   */
  private readonly _el = ngCore.inject<ngCore.ElementRef<HTMLElement>>(
    ngCore.ElementRef,
  ).nativeElement

  // TODO: This concept is so opinionated, so we might wanna to remove it if we
  // find a better way to handle this.
  /**
   * Additional context passed for a directive, so it can be accessed imperatively
   * when directive is resolved in component using ngCore.contentChild.
   *
   * @example
   * ```html
   *  <div [atnDsMeasuredElement]="attribute.id"></div>
   * ```
   */
  public readonly context = ngCore.input.required<TContext>({
    alias: 'atnDsMeasuredElement',
  })

  /**
   * Reactive width of the {@link _el element}
   *
   * @default 0
   */
  public readonly widthSg = ngCore.signal(0)

  /**
   * Initial width of the {@link _el element}
   *
   * @default 0
   */
  public readonly initialWidthSg = ngCore.signal(0)

  /**
   * Reactive height of the {@link _el element}
   *
   * @default 0
   */
  public readonly heightSg = ngCore.signal(0)

  /**
   * Initial height of the {@link _el element}
   *
   * @default 0
   */
  public readonly initialHeightSg = ngCore.signal(0)

  // TODO: implement other properties, such as height, position etc...

  constructor() {
    new ResizeObserver(this._resize.bind(this)).observe(this._el)
  }

  /** TODO:  */
  private _resize($event: ResizeObserverEntry[]): void {
    const htmlElement = $event[0].target

    const elWidth = htmlElement.clientWidth
    const elHeight = htmlElement.clientHeight

    this.widthSg.set(elWidth)
    this.heightSg.set(elHeight)

    if (elWidth > 0 && this.initialWidthSg() === 0) {
      this.initialWidthSg.set(elWidth)
    }

    if (elHeight > 0 && this.initialHeightSg() === 0) {
      this.initialHeightSg.set(elHeight)
    }
  }
}
